<div class="sc-radio-group"><ng-content></ng-content></div>